"use client";

import { useAuth } from "@clerk/nextjs";
import { useEffect } from "react";
import { setAuthToken, setTokenGetter } from "@/lib/api";

export function AuthProvider({ children }: { children: React.ReactNode }) {
    const { getToken, isLoaded } = useAuth();

    useEffect(() => {
        // Register the token getter function with the API client
        setTokenGetter(getToken);

        const updateAuthToken = async () => {
            if (isLoaded) {
                try {
                    const token = await getToken();
                    setAuthToken(token);
                } catch (error) {
                    console.error("Failed to get auth token:", error);
                    setAuthToken(null);
                }
            }
        };

        updateAuthToken();

        // Refresh token every 5 minutes to keep it fresh
        const interval = setInterval(updateAuthToken, 5 * 60 * 1000);

        return () => clearInterval(interval);
    }, [getToken, isLoaded]);

    return <>{children}</>;
}
